import React from 'react'

import useStyles from './styles'

const MainHeadline = ({ text }) => {
  const classes = useStyles()
  return <div className={classes.main_headline}>{text}</div>
}
export default MainHeadline
